export default __webpack_public_path__ + "static/media/zoom.020bdd0d.svg";